import FileUpload from './form/FileUpload';
import FileListRender from './render/FileListRender';
import ProductListDialog from "./dialog/ProductListDialog";
import PanelList from './render/PanelList';
import OrderStateRender from './render/OrderStateRender';
import AfterSaleStateRender from './render/AfterSaleStateRender';
import ClientInfoRender from "./render/ClientInfoRender";
import ClientSelectList from "./form/ClientSelectList";
import ClientSelectDialog from "./form/ClientSelectDialog";

const components = [
    FileUpload,
    FileListRender,
    ProductListDialog,
    PanelList,
    OrderStateRender,
    AfterSaleStateRender,
    ClientInfoRender,
    ClientSelectList,
    ClientSelectDialog,
];

const install = function (Vue, opts={})
{
    for (let component of components)
    {
        Vue.component(component.name, component);
    }
    Vue.prototype.priceFormat = function (price, fractionDigits=4) {
        const defaultPrice = (0).toFixed(fractionDigits);

        if ( typeof price !== 'number' && Number.isNaN(parseFloat(price)) )
            return defaultPrice;

        return parseFloat(price).toFixed(fractionDigits);
    };
    Vue.prototype.currencyRateFormat = Vue.prototype.priceFormat;
};

export default {
    install,
}



// WEBPACK FOOTER //
// ./src/modules/erp/components/index.js